import { Spin } from "antd";
import type { Sale } from "@/modules/sales/types/sales.types";
import { formatMoney } from "@/shared/utils/money";
import type { ClientDetail } from "../types/clients.types";

interface ClientSalesTabProps {
	client: ClientDetail;
	isLoading?: boolean;
	sales?: Sale[];
}

function formatAmount(value: number) {
	return `${formatMoney(value)} UZS`;
}

function getSaleRows(client: ClientDetail, sales: Sale[] = []) {
	if (sales.length === 0) {
		return client.salesHistory;
	}

	return sales.map((sale) => ({
		id: sale.saleNumber ? `#${sale.saleNumber}` : sale.id,
		room: sale.roomNumber,
		date: sale.createdAt,
		amount: formatAmount(sale.finalPrice),
		status: sale.status,
	}));
}

function getStatusLabel(status: string) {
	if (status === "faol" || status === "active") {
		return "Faol";
	}
	if (status === "yakunlangan") {
		return "Yakunlangan";
	}
	return "Bekor qilingan";
}

function getStatusTone(status: string) {
	if (status === "faol" || status === "active") {
		return "green";
	}
	if (status === "yakunlangan") {
		return "slate";
	}
	return "red";
}

export function ClientSalesTab({ client, isLoading = false, sales = [] }: ClientSalesTabProps) {
	const saleRows = getSaleRows(client, sales);

	return (
		<div className="crm-card crm-sales-table-card">
			<div className="crm-card-head">
				<h3 className="font-bold">Sotuvlar tarixi</h3>
			</div>
			<div className="crm-table-wrap">
				<table className="crm-table">
					<thead>
						<tr>
							<th>Sotuv</th>
							<th>Xona</th>
							<th>Sana</th>
							<th>Summa</th>
							<th>Holat</th>
						</tr>
					</thead>
					<tbody>
						{isLoading ? (
							<tr>
								<td colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
									<Spin size="small" />
								</td>
							</tr>
						) : saleRows.length === 0 ? (
							<tr>
								<td colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
									<span className="crm-user-role">Sotuvlar tarixi mavjud emas</span>
								</td>
							</tr>
						) : (
							saleRows.map((sale) => (
								<tr key={sale.id}>
									<td data-label="Sotuv">
										<strong className="font-bold">{sale.id}</strong>
									</td>
									<td data-label="Xona">{sale.room}</td>
									<td data-label="Sana">{sale.date}</td>
									<td data-label="Summa">{sale.amount}</td>
									<td data-label="Holat">
										<span className={`crm-badge ${getStatusTone(sale.status)}`}>
											{getStatusLabel(sale.status)}
										</span>
									</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
